import React from 'react'
import { withI18nContext } from '@mc/i18n'
import { FreeTrialStickyFooter } from '../../free-trial'
import { GuestPassStickyFooter } from '../../guest-pass'
import { i18nInstance } from '../../i18n'
import { useFreeTrial } from '../../lib'

const StickyFooterComp = () => {
  const { trial } = useFreeTrial()

  if (!trial.eligible) return null

  if (trial.isGuestPass) return <GuestPassStickyFooter />

  return <FreeTrialStickyFooter />
}

export const StickyFooter = withI18nContext(i18nInstance)(StickyFooterComp)
